const getFirstAvailableTenant = (tenants) => {
  for (let tenant of tenants) {
    if (tenant.locationsNumber > 0) {
      return tenant;
    }
  }
};

export { getFirstAvailableTenant };
